import React from 'react';
import { useSitrepSectionWizardContext } from './SitrepSectionWizardContext';
import { PratusStepper } from '../../DesignSystems/PratusStepper/PratusStepper';
import { SITREP_SECTION_STEPS } from './types';
import { StylishNewButton } from '../../DesignSystems/New/StylishNewButton';
import { SharedIcon } from '../../SharedIcon/SharedIcon';

/**
 * This component renders the stepper and label for each step in the Sitrep
 * Section Wizard.
 */
type SitrepSectionWizardHeaderProps = {
  setIsEditingSitrepSections: (isEditing: boolean) => void;
};

const SitrepSectionWizardHeader = ({
  setIsEditingSitrepSections,
}: SitrepSectionWizardHeaderProps) => {
  const { activeStep } = useSitrepSectionWizardContext();
  return (
    <>
      <StylishNewButton
        className={'button button--link p-3 justify-content-end'}
        onClick={() => setIsEditingSitrepSections(false)}
      >
        <SharedIcon iconName="close" classes="text-white" />
      </StylishNewButton>
      <div className="sidebar-header">
        <div className="stepper-container px-3">
          <PratusStepper
            steps={SITREP_SECTION_STEPS}
            activeStep={activeStep.id}
            showLabel={false}
          />
        </div>
        <h3 className="align-self-center m-0">{activeStep.label}</h3>
      </div>
    </>
  );
};

export default SitrepSectionWizardHeader;
